import { FC, ReactNode } from "react";
import { IoClose } from "react-icons/io5";

interface ModalProps {
  isOpen: boolean;
  children: ReactNode;
  onClose?: () => void;
  title?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
}

const Modal: FC<ModalProps> = ({
  children,
  onClose,
  title,
  isOpen,
  size = "sm",
}) => {
  if (!isOpen) return null;
  const sizeClass =
    size === "sm"
      ? "max-w-md"
      : size === "md"
        ? "max-w-lg"
        : size === "lg"
          ? "max-w-xl"
          : size === "xl"
            ? "max-w-2xl"
            : size === "2xl"
              ? "max-w-3xl"
              : size === "3xl"
                ? "max-w-4xl"
                : "max-w-5xl";

  return (
    <div className="fixed inset-0 z-10 overflow-y-auto">
      <div className="fixed inset-0 w-full h-full bg-black opacity-50" />
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className={`relative w-full ${sizeClass} p-3 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl`}>
          <div className="flex items-center justify-between">
            <h6 className="text-md font-bold text-gray-900 ">{title}</h6>
            {
              onClose && (
                <button
                  onClick={onClose}
                  type="button"
                  className="text-gray-600 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-6 h-6 transition-all duration-200 flex justify-center items-center"
                >
                  <IoClose size={16} />
                </button>
              )
            }
            
          </div>
          <div className="">{children}</div>
        </div>
      </div>
    </div>
  );
};

export { Modal };
